import { render, staticRenderFns } from "./StudioTemplate.vue?vue&type=template&id=510e37bc&scoped=true&"
import script from "./StudioTemplate.vue?vue&type=script&lang=js&"
export * from "./StudioTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StudioTemplate.vue?vue&type=style&index=0&id=510e37bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e37bc",
  null
  
)

export default component.exports